import HttpClientToken from '../../services/HttpClientToken';
import HttpClientApiKey from '../../services/HttpClientApiKey';
import HttpClientFormData from '../../services/HttpClientFormData';

import { AxiosError } from 'axios';

import { HttpResponse } from '../../interfaces/auth/AuthInterface';

import { ActualizarEstatusParams, ObtenerTipoServicioUnidadResponse, TipoServicioProps, TipoServicioResponse } from '../../interfaces/catalogos/TipoServicioInterface';

export const TipoServicios = () => {

    return new Promise<TipoServicioProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClientToken.get('/Api/TipoServicio/', token)
            .then( ({ data } : { data : TipoServicioProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerTipoServicios = () => {

    return new Promise<TipoServicioProps[]>( (resolve, eject) => {     

        HttpClientApiKey.get('/Api/TipoServicio/ObtenerTipoServicios')
        .then( ({ data } : { data : TipoServicioProps[] } ) => {               
            resolve( data );                
        })
        .catch( () => {
            resolve( [] );
        });        

    });

}

export const ActualizarTipoServicio = ( params: FormData ) => {

    return new Promise<TipoServicioResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClientFormData.post('/Api/TipoServicio/Actualizar', params, token)
            .then( ({ data } : { data : TipoServicioResponse} ) => {               
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                    idTipoServicio: 0,
                    descripcion: '',      
                    idUnidad: 0, 
                    unidad: '',
                    imagen: '',
                });
            });
        }

    });

}

export const AgregarTipoServicio = ( params: FormData ) => {

    return new Promise<TipoServicioResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClientFormData.post('/Api/TipoServicio/Agregar', params, token)
            .then( ({ data } : { data : TipoServicioResponse} ) => {               
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve( {
                    success: false,
                    message: error.message,
                    idTipoServicio: 0,
                    descripcion: '',      
                    idUnidad: 0, 
                    unidad: '',
                    imagen: '',
                });
            });
        }

    });

}

export const ActualizarEstatusTipoServicio = ( params: ActualizarEstatusParams ) => {

    return new Promise<HttpResponse>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClientToken.post('/Api/TipoServicio/ActualizarEstatus', params, token)
            .then( ({ data } : { data : HttpResponse} ) => {               
                resolve( data );                
            })
            .catch( ( error: AxiosError ) => {
                resolve({
                    success: false,
                    message: error.message,
                });
            });
        }

    });

}

export const ObtenerTipoServiciosUnidad = ( id: number ) => {

    return new Promise<ObtenerTipoServicioUnidadResponse>( (resolve, eject) => {     

        HttpClientApiKey.get(`/Api/TipoServicio/ObtenerTipoServiciosUnidad/${ id }`)
        .then( ({ data } : { data : ObtenerTipoServicioUnidadResponse } ) => {               
            resolve( data );                
        })
        .catch( () => {
            resolve( {
                unidad: '',
                servicios: [],
            });
        });        

    });

}